// @flow
import * as React from 'react';
import LocaleContext from 'contexts/localeContext';

export default BaseComponent => props => (
  <LocaleContext.Consumer>
    {contexts => <BaseComponent {...props} {...contexts} />}
  </LocaleContext.Consumer>
);
